import { DEFAULT_INPUT_MAX_LENGTH } from '../constants';
import { FormatFunction } from '../types';

import { Mask } from './Mask';

export class DefaultMask extends Mask {
  constructor(maxLength: number = DEFAULT_INPUT_MAX_LENGTH) {
    super('', maxLength);
  }

  format: FormatFunction = (value: string, { selectionStart }) => {
    return { maskedValue: value, cursorPosition: selectionStart };
  };

  unformat = (value: string) => {
    return value;
  };
}
